import React, {ReactElement, ReactNode, useEffect, useState} from 'react'

import classnames from "classnames"

import "styles/components/popup.sass"

import {ReactComponent as Close} from "pages/Icons/size24/Close.svg"
import _ from "lodash";
import {useMediaQuery} from "@mui/material";
import {mobileMaxWidthMediaQuery} from "../methods/utils";

type Props = {
  children: ReactElement,
  onClose?: Function,
  maxWidth?: string,
  padding?: string,
  background?: string
  style?: any,
  wrapperStyle?: any,
  wrapperClassName?: string,
  id?: string,
  /** className на корневом `.popup` (например, модификаторы отступа/слоёв) */
  className?: string,
  /** Содержимое слева в верхней строке (заголовок, действия) — вместо пустого `div` */
  titleNode?: ReactNode,
}

function Popup({ children, onClose, maxWidth, padding, background, style = {}, wrapperStyle = {}, wrapperClassName, className, titleNode, }: Props) {

  const [isClosing, runClosingAnimation] = useState(false)
  const [mouseDownElement, setMouseDownElement] = useState<any>(null)

  const mobile = useMediaQuery(mobileMaxWidthMediaQuery)

  const close = () => {
    if (!onClose) return
    runClosingAnimation(true)
    setTimeout(onClose, 320)
  }

  useEffect(() => {
    const handleEsc = (event: any) => {
      if (event.key === 'Escape') {
        close()
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [])

  const wrapper = <div
      className={classnames("wrapper", wrapperClassName)}
      style={{maxWidth: maxWidth ?? "650px", background: background, ...wrapperStyle}}
      onClick={(event) => {
        event.stopPropagation()
      }}
  >
    {
        onClose &&
        <div className="titleContainer">
          {titleNode ?? <div/>}
          <button className="new smallIconed close-button" onClick={() => close()}>
            <Close className="icon" style={{stroke: "#75809E"}} />
          </button>
        </div>
    }
    <div className="popupContainer" style={{padding: padding}}>
      {children}
    </div>
  </div>

  return (
    <div
      className={classnames('popup', { _isClosing: isClosing }, className)}
      style={{ ...style }}
    >
      <div className="popup__dim" aria-hidden />
      <div className="popup__scroll">
        <div
          className="clickable-area"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget && !mobile) {
              setMouseDownElement(_.get(e.target, "className"))
            }
          }}
          onMouseUp={(e) => {
            let targetClassName = _.get(e.target, "className", "")
            if (e.target === e.currentTarget && !mobile && targetClassName === 'clickable-area' && targetClassName === mouseDownElement) {
              close()
            }
          }}
        >
          {wrapper}
        </div>
      </div>
    </div>
  )
}

export default Popup
